import { AuthProvider } from "react-admin";

import { z } from "zod";

const PermissionName = z.string();

const OrganScopeSchema = z.object({
	organ: z.number(),
});

const TeamScopeSchema = z.object({
	team: z.number(),
});

const TeamRoleScopeSchema = z.object({
	team: z.number(),
	target_role: z.number(),
});

const PermissionsSchema = z.object({
	global: z.array(PermissionName),
	organ: z.record(PermissionName, z.array(OrganScopeSchema)),
	team_role_assignment: z.record(PermissionName, z.array(TeamRoleScopeSchema)),
});

export type Permissions = z.infer<typeof PermissionsSchema>;
export type TeamScope = z.infer<typeof TeamScopeSchema>;

export const REDIRECT_AFTER_NEXT_LOGIN = "redirect_after_next_login";

const storeLocation = () => {
	if (window.location.href.endsWith("#/login")) return;

	sessionStorage.setItem(
		REDIRECT_AFTER_NEXT_LOGIN,
		encodeURIComponent(window.location.href)
	);
};

export const authProvider: AuthProvider = {
	login: () => Promise.reject(), // don't need this - we redirect user to Azure intead of asking for credentials

	checkError: ({ status }) =>
		status === 401 ? Promise.reject() : Promise.resolve(),

	checkAuth: () =>
		fetch("/api/users/me").then((response) => {
			if (response.ok) {
				return Promise.resolve();
			} else {
				storeLocation();
				return Promise.reject({ message: false });
			}
		}),

	logout: () =>
		fetch("/auth/logout")
			.then((response) => response.json())
			.then((data) =>
				data.redirect_url
					? `/logout?redirect_url=${encodeURIComponent(data.redirect_url)}`
					: undefined
			)
			.catch((error) => console.error("Logout endpoint error", error)),

	getIdentity: () =>
		fetch("/api/users/me")
			.then((response) => response.json())
			.then((data) => ({
				id: data.id,
				fullName: `${data.first_name} ${data.last_name}`,
				admin: data.admin,
			})),

	getPermissions: (): Promise<Permissions> =>
		fetch("/api/users/me/permissions")
			.then((response) => response.json())
			.then(PermissionsSchema.parse),
};
